import React from 'react';
import { ImageListItem, Dialog } from '@mui/material';
import { width } from '@mui/system';

const SingleImageDialog = ({ imageSrc }) => {
    const [open, setOpen] = React.useState(false);

    // Add cache busting (optional but effective)
    const cacheBustedSrc = `${imageSrc}?t=${new Date().getTime()}`;

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <>
            <ImageListItem onClick={handleClickOpen} sx={{ cursor: 'pointer', width: 120, height: 120 }}>
                <img src={`${cacheBustedSrc}`} alt={''}
                    style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover', // or 'contain' depending on your needs
                        borderRadius: 4,
                    }}
                />
            </ImageListItem>
            <Dialog fullWidth maxWidth="md" open={open} onClose={handleClose}>
                <img src={`${cacheBustedSrc}`} alt={''} />
            </Dialog>
        </>
    );
};

export default SingleImageDialog;
